/*
 * Purpose: Pricing subhead A/B test — variant assignment + copy (v1)
 * Last modified: 2026-06-29 | Agent
 * Completeness: 96
 */
import { PRODUCT_TERMS } from '@/lib/productTerms';

export const PRICING_SUBHEAD_EXPERIMENT_ID = 'pricing_subhead_v1';

export type PricingSubheadVariant = 'a' | 'b';

const ASSIGNMENT_KEY = 'autoblocks:exp-pricing-subhead-v1';

const BRAND = PRODUCT_TERMS.productBrand;

/** Control — benefit-focused, no competitor call-out */
export const PRICING_SUBHEAD_VARIANT_A = `${BRAND} is outcome-driven automation on flat plans — predictable pricing, not per-step billing. Checkout is secure via Stripe.`;

/** Challenger — opens with Zapier per-task attack line */
export const PRICING_SUBHEAD_VARIANT_B = `Stop paying Zapier for every task and connector hop. ${BRAND} is outcome-driven automation on flat plans — predictable pricing, not per-step billing. Checkout is secure via Stripe.`;

export function getPricingSubheadCopy(variant: PricingSubheadVariant): string {
  return variant === 'b' ? PRICING_SUBHEAD_VARIANT_B : PRICING_SUBHEAD_VARIANT_A;
}

export function getPricingSubheadVariantLabel(variant: PricingSubheadVariant): string {
  return variant === 'b' ? 'B — Zapier attack + benefit' : 'A — benefit only';
}

/** Sticky 50/50 assignment per browser (independent of analytics consent). */
export function assignPricingSubheadVariant(): PricingSubheadVariant {
  if (typeof window === 'undefined') return 'a';

  const stored = localStorage.getItem(ASSIGNMENT_KEY);
  if (stored === 'a' || stored === 'b') return stored;

  const variant: PricingSubheadVariant = Math.random() < 0.5 ? 'a' : 'b';
  localStorage.setItem(ASSIGNMENT_KEY, variant);
  return variant;
}
